import React, { useLayoutEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { BsFillMoonStarsFill, BsSunFill } from 'react-icons/bs'
import { HiMenuAlt3 } from 'react-icons/hi'

import { UseGlobalContext } from '../../Hooks/UseContext'
import { logo } from '../../Assets/index.js'
import { themeSwitcher } from '../../utils/functions'
import { styles } from '../../styles'

const Navbar = () => {
  const [first, setFirst] = useState('')
  const [usertheme, setUsertheme] = useState('')
  const [systemtheme, setsystemtheme] = useState(false)
  const [active, setActive] = useState('')
  const { TRA, DRM, isMobileMenuOpen, setIsMobileMenuOpen } = UseGlobalContext()
  const darkmodeRef = useRef(null)
  const lightmodeRef = useRef(null)

  const handleTRA = (e) => {
    const _ = e.target.getBoundingClientRect()
    console.log(_)
    TRA({
      page: e.target.textContent,
      top: _.bottom + 3,
      center: (_.right + _.left) / 2,
    })
  }

  useLayoutEffect(() => {
    const userTheme = localStorage.getItem('theme')
    const systemTheme = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches
    setUsertheme(userTheme)
    setsystemtheme(systemTheme)
    console.log(userTheme, first)
    DRM(userTheme)
  }, [first, usertheme, DRM])

  return (
    <>
      <nav
        className={`sm:px-8 px-6 w-full flex items-center justify-between py-1.5 2xl:py-3 fixed top-0 z-30 dark:bg-primary bg-white_color shadow-lg`}
      >
        <section className='flex justify-between items-center mx-auto'>
          <Link
            to={`/`}
            className='flex items-center gap-2'
            onClick={() => {
              setActive('')
              window.scrollTo(0, 0)
              window.location.reload()
            }}
          >
            <img src={logo} alt='logo' className='w-9 h-9 object-contain' />
            <p className='flex flex-row dark:text-white text-[#050816] text-[18px] font-bold cursor-pointer'>
              Sanctus&nbsp;
              <span className=' items-center justify-center hidden xs:flex'>
                ||&nbsp;CHRISTSANTUS
              </span>
            </p>
          </Link>
        </section>
        <ul className='list-none hidden md:flex flex-row gap-3 lg:gap-9 '>
          {/* <DNM /> */}
          {[
            'home',
            'about',
            'skills',
            'exprience',
            'work',
            'testimonails',
            'contact',
          ].map((link, i) => (
            <li
              key={i}
              onMouseOver={(e) => {
                e.stopPropagation()
                handleTRA(e)
              }}
              onClick={() => setActive(link)}
              className={`
              ${
                active === link
                  ? 'dark:text-white text-gray-700'
                  : 'dark:text-secondary text-gray-800'
              }

            ${i === 2 && 'hidden mmd:block'}
            ${i === 4 && 'hidden mmd:block'}
              capitalize dark:hover:text-white hover:text-gray-700 text-[18px] font-normal lgfont-medium`}
            >
              <a href={`#${link}`}>{link}</a>
            </li>
          ))}
        </ul>
        <section className=' justify-end items-center mx-auto  flex-row '>
          {usertheme === 'darkmode' && (
            <button
              type='button'
              className='bg-white_color w-[40px] h-[40px] rounded-full my-1 flex justify-center items-center transition-all border-2 border-lightGray_color dark:bg-tertiary shadow-lg light'
              ref={lightmodeRef}
              onClick={() => {
                setFirst('the state is set to light mode')
                themeSwitcher(lightmodeRef)
              }}
            >
              <BsSunFill className={`${styles.socials}`} />
            </button>
          )}

          {usertheme === 'light' && (
            <button
              type='button'
              className={`bg-white_color w-[40px] h-[40px] rounded-full my-1 flex justify-center items-center transition-all border-2 border-lightGray_color dark:bg-tertiary shadow-lg darkmode`}
              onClick={() => {
                setFirst('the state is set to dark mode')
                themeSwitcher(darkmodeRef)
              }}
              ref={darkmodeRef}
            >
              <BsFillMoonStarsFill className={`${styles.socials}`} />
            </button>
          )}
        </section>

        <section className=' flex justify-end items-center mmd:hidden'>
          <HiMenuAlt3
            className='w-[32px] h-[32px] text-primary dark:text-white object-contain cursor-pointer z-50'
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />
        </section>
      </nav>
    </>
  )
}

export default Navbar
